import { Component, OnInit } from '@angular/core';

import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IoBasculaService } from '../../services/general-services/iobascula.services';
import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { PlantaService } from '../../services/general-services/planta.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { Planta } from '../../models/planta';


@Component({
  selector: 'app-mantenedor-balanzade-linea',
  templateUrl: './mantenedor-balanzade-linea.component.html',
  styleUrls: ['./mantenedor-balanzade-linea.component.css']
})

export class MantenedorBalanzadeLineaComponent implements OnInit {
  
  titulo: string = "Mantener Balanzas con Plantas";
  constantesDelModulo = moduloPerform;
  
  public DAT_TITULOS  : any = this.constantesDelModulo.titulos.balanzaPlanta;
  public DAT_BTNS     : any = this.constantesDelModulo.button.buttonsNombre;
  public DAT_BTNCSS   : any = this.constantesDelModulo.button.buttonsCss;
  public DAT_MSG      : any = this.constantesDelModulo.mensajes;
  public DAT_AG_GRID  : any = this.constantesDelModulo.agGrid;

  public columnDefs     : any[] = [];
  public rowData        : any[] = [];
  public gridApi        : any;
  public gridColumnApi  : any;
  public frameworkComponents: any;

  public loading    : boolean = false;
  public isCreate   : boolean;
  public tituloModal: string;
  public validIP    : boolean = false;

  cmbPlantas        : any[] = [];
  cmbPlanta         : Planta[] = [];
  
  cmbEstado: any[] = [
    { clave: 1, valor: 'Activo' },
    { clave: 2, valor: 'Inactivo' }
  ];

  
  public formulario = new FormGroup({
    idBascula : new FormControl([], Validators.required),
    ipBalanza : new FormControl('', [Validators.required, Validators.pattern(/(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/), Validators.maxLength(14)]),
    desca     : new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      Validators.pattern(/[A-Za-z]+/)
    ]),
    estado    : new FormControl('1', Validators.required),
    plantaId  : new FormControl('' , Validators.required),
    creadoPor : new FormControl('' , Validators.required),
  });

  constructor(
    private _util: UtilsService, 
    private _basculasIoAPI: IoBasculaService,
    private _plantaAPI    : PlantaService,
    private _dmaestrosApi : DatosMaestrosService,
    private _commonForm   : CommonFormService
  ) { 
    this.formulario.get('idBascula').disable();
  }


  ngOnInit(): void {
    this.gridComponent();
    this.inicializarCombos();
  }

  inicializarCombos(){
    this.loading = true;
    this.rowData = [];

    //Obtiene listado de basculas
    this._basculasIoAPI.getAllBasculas().subscribe(
      (resp) => {
        this.rowData = resp;
      },(error) => {
        console.log(error);
      }
    );
    
    this.loading = false;

    //Obtiene listado de plantas
    this._plantaAPI.getAll().subscribe(
      (resp) => {
        this.cmbPlantas = resp;
      },(error) => {
        this.cmbPlantas = [];
      }
    );

    this._plantaAPI.getAllbyPerfor().subscribe((res: any) => {
      this.cmbPlanta = res.respuesta;
    }, (err) => {
      this.cmbPlanta = [];
    });

    this.getAllPlantaByUser();

  }

  getAllPlantaByUser() {
    this._plantaAPI.getAllbyPerforByUser(localStorage.getItem('userName')).subscribe((res: any) => {
      console.log('load',res.respuesta);
      this.cmbPlanta = res.respuesta;
    }, (err) => {
      console.log('err',err);
      this._util.mensajeErroToast("No se encontro Plantas asignadas a su usuario, por favor contacte al administrador",3000);
      this.cmbPlanta = [];
    });
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      //{headerName: 'Id',  field: 'idBascula', sortable: true,  filter: true, width: 80 },
      {headerName: 'Descripción', field: 'desca', sortable: true, filter: true},
      {headerName: 'IP', field: 'ipBalanza', sortable: true, filter: true,},
      {field: 'plantaId', sortable: true, filter: true, },
      {field: 'planta', sortable: true, filter: true, },
      {headerName: 'Estado', field: 'estado', sortable: true, filter: true, 
        valueGetter: function(params) { return (params.data.estado == 1) ? 'ACTIVO' : 'INACTIVO';  }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        cellRendererParams: {
          onClick: this.editarRegistro.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
    ];

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  nuevoRegistro() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    
    this.formulario.reset();
    this.formulario.get('creadoPor').setValue(localStorage.getItem('userName'));
    
    this.openModal();
  }
  
  editarRegistro({rowData}) {
    this.isCreate     = false;
    this.tituloModal  = this.DAT_TITULOS.tituloActualizar;
    rowData.estado    = rowData.estado == 'ACTIVO' ? 1 : 2;
    rowData.modificadoPor = localStorage.getItem('userName');
    this.formulario.patchValue(rowData);

    this.openModal();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    this.crearActualizarRegistro();
  }

  crearActualizarRegistro() {
    this.loading = true;
    if (this.formulario.invalid) return;

    let data = this.formulario.getRawValue();

    this._util.confirmarSincronoPromesa({
      title   : this.DAT_MSG.procesar,
      text    : `Ip: ${data.ipBalanza}, Descripción: ${data.desca}`,
      action  : this.isCreate ? "Crear Registro" : "Actualizar Registro",
      funcion : this.isCreate ? this._basculasIoAPI.saveBascula(data) : this._basculasIoAPI.updateBascula(data),
    }).then(() => {
      this.inicializarCombos();
      this.loading = false;
      this.closeModal();
    }).catch(() => {
      this.loading = false;
    });

  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  duplicatedIP() {
    this.validIP = false;

    for (let i = 0; i < this.rowData.length; i++) {
      if (this.formulario.get('ipBalanza').value == this.rowData[i].ipBalanza) {
        if (this.formulario.get('idBascula').value == this.rowData[i].idBascula) continue;
        this.validIP = true;
        break;
      }
    }
    console.log("this.validIP", this.validIP);

  }

  validForm() {
    console.log(this.formulario.invalid);
    return (this.formulario.invalid || this.validIP) ? true : false;
  }

}
